module.exports = __webpack_public_path__ + "img/capilaridade.354824a8.png";